import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CustomizationImagePickerDto, CustomizationType, ImagePickerActionsDto } from '../../../../../../../api/src/creative-unit-package/models/customization/customization.dto';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { GlobalService } from '../../../../_core/state/global';
import { SessionQuery } from '../../../../_core/state/session';
import { AssetDto } from '../../../../../../../api/src/asset/models/asset.dto';
import { AdStudioContainerQuery } from '../../../../_core/state/ad/ad-container.query';

@Component({
  selector: 'app-image-tool-crop',
  templateUrl: './image-tool-crop.component.html',
  styleUrl: './image-tool-crop.component.scss'
})
export class ImageToolCropComponent implements OnChanges {
	@Input() targetCropConfig: ImagePickerActionsDto['targetCropConfig'];
	@Input() activeAsset: AssetDto;
	@Output() targetCropConfigChange: EventEmitter<Partial<ImagePickerActionsDto['targetCropConfig']>> = new EventEmitter<Partial<ImagePickerActionsDto['targetCropConfig']>>();
	@Output() activeAssetChange: EventEmitter<Partial<AssetDto>> = new EventEmitter<Partial<AssetDto>>();

	public form: UntypedFormGroup;
	public isAtLeastAdmin = this.sessionQuery.isAtLeastAdmin();
	public isEditor = this.adStudioContainerQuery.getAppContext() === 'editor';

	constructor(
		private readonly globalService: GlobalService,
		private readonly sessionQuery: SessionQuery,
		private readonly adStudioContainerQuery: AdStudioContainerQuery
	) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (!this.form ) {
			this.form = new UntypedFormGroup({
				target: new UntypedFormGroup({
					x: new UntypedFormControl(Math.round(this.targetCropConfig?.target?.x / this.targetCropConfig?.imageWidth * 100)),
					y: new UntypedFormControl(Math.round(this.targetCropConfig?.target?.y / this.targetCropConfig?.imageHeight * 100)),
					width: new UntypedFormControl(Math.round(this.targetCropConfig?.target?.width / this.targetCropConfig?.imageWidth * 100)),
					height: new UntypedFormControl(Math.round(this.targetCropConfig?.target?.height / this.targetCropConfig?.imageHeight * 100)),
				})
			});

			this.form.valueChanges.subscribe((value) => {
				this.targetCropConfigChange.emit({
					target: {
						x: Math.round(Number(value.target.x ) * this.targetCropConfig?.imageWidth / 100),
						y: Math.round(Number(value.target.y)* this.targetCropConfig?.imageHeight / 100),
						width: Math.round(Number(value.target.width)* this.targetCropConfig?.imageWidth / 100),
						height: Math.round(Number(value.target.height)* this.targetCropConfig?.imageHeight / 100)
					}
				});
			});

		} else {
			this.form.patchValue({
				target: {
					x:Math.round( Number(this.targetCropConfig?.target?.x)/ this.targetCropConfig?.imageWidth * 100),
					y: Math.round(Number(this.targetCropConfig?.target?.y)/ this.targetCropConfig?.imageHeight * 100),
					width: Math.round(Number(this.targetCropConfig?.target?.width)/ this.targetCropConfig?.imageWidth * 100),
					height: Math.round(Number(this.targetCropConfig?.target?.height)/ this.targetCropConfig?.imageHeight * 100)
				}
			}, { emitEvent: false });
		}
	}

	copySettings(): void {
		// Copy settings to clipboard.
		let copyText = document.createElement('textarea');
		copyText.value = JSON.stringify(this.targetCropConfig?.target);
		document.body.appendChild(copyText);
		copyText.select();
		document.execCommand('copy');

		copyText.remove();

		// Show toast.
		this.globalService.triggerSuccessMessage('Settings copied to clipboard');
	}



}
